export default "__VITE_ASSET__BnO9h7w9__"